module.exports = __webpack_public_path__ + "img/finance2.7a0bbc74.png";